(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices-react/deposit/assets/react/deposit-limits/deposit-limits-row.js') >= 0) return;  svs.modules.push('/components/accountservices-react/deposit/assets/react/deposit-limits/deposit-limits-row.js');
'use strict';

const formatCurrency = svs.utils.format.Currency;
const IconText = svs.tb_ui_react.icon_text.IconText;
const _svs$accountservicesR = svs.accountservicesReact.deposit.depositLimits.constants,
  TRANSLATION = _svs$accountservicesR.TRANSLATION,
  PERIODS = _svs$accountservicesR.PERIODS;
const periodText = limitType => "Ins\xE4ttningsgr\xE4ns per ".concat(TRANSLATION.get(limitType === null || limitType === void 0 ? void 0 : limitType.toUpperCase()) || '');
const DepositLimitsRow = _ref => {
  let limit = _ref.limit;
  const currentDepositBudget = limit.currentDepositBudget,
    futureDepositBudget = limit.futureDepositBudget,
    limitType = limit.limitType,
    nextTimeShift = limit.nextTimeShift,
    currentDepositAmount = limit.currentDepositAmount;
  const remainingDepositBudget = (currentDepositAmount === null || currentDepositAmount === void 0 ? void 0 : currentDepositAmount.length) && "".concat(formatCurrency(Math.min(1000000, Math.max(0, parseInt(currentDepositBudget, 10) - parseInt(currentDepositAmount, 10)))), " kr");
  const isFutureBudget = nextTimeShift && currentDepositBudget !== futureDepositBudget;
  return (
    React.createElement("div", {
      className: "".concat(limitType !== PERIODS.at(-1) && 'u-border-bottom-1', " border-grey-400 margin-bottom padding-v")
    }, React.createElement("div", {
      className: "u-flex"
    }, React.createElement("span", {
      className: "inline-block u-flex-grow-1 f-left f-medium"
    }, periodText(limitType)), React.createElement("span", null, "".concat(formatCurrency(currentDepositBudget) || '', " kr"))), React.createElement("div", {
      className: "u-flex"
    }, React.createElement("span", {
      className: "inline-block u-flex-grow-1 f-left"
    }, "Kvar att kunna s\xE4tta in"), React.createElement("span", null, remainingDepositBudget)), isFutureBudget && React.createElement("div", {
      className: "padding-bottom f-left"
    }, React.createElement(IconText, {
      size: "200"
    }, React.createElement("span", null, "Ny gr\xE4ns:", ' ', "".concat(formatCurrency(futureDepositBudget), " kr,\n             g\xE4ller fr\xE5n ").concat(dateFns.format(dateFns.parseISO(nextTimeShift), 'dd/MM HH:mm'))))))
  );
};
svs.accountservicesReact.deposit.depositLimits.DepositLimitsRow = DepositLimitsRow;

 })(window);